import React from 'react'
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';

export default function Calltoaction() {
    return (
        <section className="w-full px-4 py-15">
            <div className="max-w-5xl mx-auto">

                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                    className="relative bg-gradient-to-r from-[#072c4c] to-[#0a3d62] rounded-2xl px-6 sm:px-10 py-10 text-center overflow-hidden shadow-lg"
                >
                    {/* Background Circle */}
                    <div className="absolute top-0 right-0 w-40 h-40 bg-white/10 rounded-full blur-2xl"></div>

                    {/* Content */}
                    <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-3">
                        Ready to Explore Instant Loan Options
                    </h2>

                    <p className="text-gray-300 text-sm sm:text-base mb-6">
                        Whether it is utility bills, temporary financial gaps, or everyday commitments, B4Salary helps salaried professionals navigate short-term financial needs through a structured digital process.
                    </p>

                    {/* Button */}
                    <Link to={'/apply-now'}>
                    <button className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-6 sm:px-8 py-3 rounded-lg shadow-md transition-all duration-300 hover:scale-105">
                        Apply Online
                    </button>
                    </Link>
                </motion.div>

            </div>
        </section>
    )
}
